@if(currentMessage; as msg){
@switch (msg.style) {
@case ('success') {
<div
  class="fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg flex items-center space-x-4 transition-all duration-300 ease-out transform translate-y-0 opacity-100 bg-green-100 text-green-800 border border-green-200"
  data-cy="toast-container">
  <span class="material-symbols-outlined text-2xl">check_circle</span>
  <div class="flex-1">
    <h4 class="font-bold text-lg" data-cy="toast-text-header">{{ msg.header || 'Success' }}</h4>
    <p class="text-sm" data-cy="toast-text-content">{{ msg.content }}</p>
  </div>
  <button (click)="notify.clear()"
    class="p-1 rounded-full hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-green-500"
    data-cy="toast-button-close">
    <span class="material-symbols-outlined text-xl">close</span>
  </button>
</div>
}
@case ('error') {
<div
  class="fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg flex items-center space-x-4 transition-all duration-300 ease-out transform translate-y-0 opacity-100 bg-red-100 text-red-800 border border-red-200"
  data-cy="toast-container">
  <span class="material-symbols-outlined text-2xl">error</span>
  <div class="flex-1">
    <h4 class="font-bold text-lg" data-cy="toast-text-header">{{ msg.header || 'Error' }}</h4>
    <p class="text-sm" data-cy="toast-text-content">{{ msg.content }}</p>
  </div>
  <button (click)="notify.clear()"
    class="p-1 rounded-full hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500"
    data-cy="toast-button-close">
    <span class="material-symbols-outlined text-xl">close</span>
  </button>
</div>
}
@case ('error') {
<div
  class="fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg flex items-center space-x-4 transition-all duration-300 ease-out transform translate-y-0 opacity-100 bg-orange-100 text-orange-800 border border-orange-200"
  data-cy="toast-container">
  <span class="material-symbols-outlined text-2xl">warning</span>
  <div class="flex-1">
    <h4 class="font-bold text-lg" data-cy="toast-text-header">{{ msg.header || 'Warning' }}</h4>
    <p class="text-sm" data-cy="toast-text-content">{{ msg.content }}</p>
  </div>
  <button (click)="notify.clear()"
    class="p-1 rounded-full hover:bg-orange-200 focus:outline-none focus:ring-2 focus:ring-orange-500"
    data-cy="toast-button-close">
    <span class="material-symbols-outlined text-xl">close</span>
  </button>
</div>
}
@default {
<div
  class="fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg flex items-center space-x-4 transition-all duration-300 ease-out transform translate-y-0 opacity-100 bg-sky-100 text-sky-800 border border-sky-200"
  data-cy="toast-container">
  <span class="material-symbols-outlined text-2xl">info</span>
  <div class="flex-1">
    <h4 class="font-bold text-lg" data-cy="toast-text-header">{{ msg.header || 'Notification' }}</h4>
    <p class="text-sm" data-cy="toast-text-content">{{ msg.content }}</p>
  </div>
  <button (click)="notify.clear()"
    class="p-1 rounded-full hover:bg-sky-200 focus:outline-none focus:ring-2 focus:ring-sky-500"
    data-cy="toast-button-close">
    <span class="material-symbols-outlined text-xl">close</span>
  </button>
</div>
}
}
}